import * as React from 'react';
import { render } from 'react-dom';
import { Shoppers } from '../landing_pages/pages/Shoppers';
import '../terms_and_conditions/styles.scss';

const root = document.getElementById('shoppers');
render(<Shoppers />, root);
